import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Line } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

const DASHES_HORIZONTAL = 'h';
const DASHES_VERTICAL = 'v';

function dashes(orientation) {
  function Component(props) {
    const {
      stroke,
      strokeWidth: strokeWidthRaw,
      strokeDasharray,
      horizontalWidth,
    } = props;
    const strokeWidth = parseFloat(strokeWidthRaw);

    if (orientation === DASHES_HORIZONTAL) {
      let widthValue = horizontalWidth == undefined ? '100%' : horizontalWidth;
      return (
        <Svg style={{ height: strokeWidth }} width={widthValue} height="20px">
          <Line
            x1="0"
            y1="50%"
            x2="100%"
            y2="50%"
            {...{ stroke, strokeWidth, strokeDasharray }}
          />
        </Svg>
      );
    }

    return (
      <Svg style={{ width: strokeWidth }} height="30%">
        <Line
          x1="50%"
          y1="0"
          x2="50%"
          y2="100%"
          {...{ stroke, strokeWidth, strokeDasharray }}
        />
      </Svg>
    );
  }

  Component.propTypes = {
    stroke: PropTypes.string,
    strokeWidth: PropTypes.number,
    strokeDasharray: PropTypes.arrayOf(PropTypes.number),
  };
  Component.defaultProps = {
    stroke: 'white',
    strokeWidth: 1,
    strokeDasharray: [3, 2],
  };

  return pure(Component);
}

/**
 * Use HorizontalDashes inside a parent that has flexDirection: 'column' and
 * alignItems: 'stretch' (the RN default)
 */
const HorizontalDashes = dashes(DASHES_HORIZONTAL);

/**
 * Use VerticalDashes inside a parent that has flexDirection: 'row' and
 * alignItems: 'stretch'. E.g. if you want to add padding above and below the
 * dashed line, you could do:
 *
 *   <View style={{flexDirection: 'row', paddingVertical: 20}}>
 *     <VerticalDashes />
 *   </View>
 */
const VerticalDashes = dashes(DASHES_VERTICAL);

export { HorizontalDashes, VerticalDashes };
